import { useState } from 'react'
import { TopMenuButton } from './freeroamMenuButton/TopMenuButton'
import './TopMenu.css'
import { TopMenuProps } from './TopMenu.types'

export const TopMenu = ({ pages, initPage, styles }: TopMenuProps) => {

	const [page, setPage] = useState<string>(initPage || pages[0].name)

	const changePage = (pageName: string) => {
		pages.find((page) => page.name === pageName)?.onClick()
		setPage(pageName)
	}

	return (
		<div className='top-menu'>
			{pages.map((currentPage, index) => {
				return (
					<TopMenuButton
						key={`${currentPage.name}-${JSON.stringify(styles)}`}
						text={currentPage.text}
						onClick={() => changePage(currentPage.name)}
						isActive={currentPage.name === page}
						styles={styles}
					/>
				)
			})}
		</div>
	)
}